import { Swiper, Navigation, EffectFade } from 'swiper'

Swiper.use([Navigation, EffectFade])

const $slider = document.querySelector('.testimonials-slider')

const state = {
  numSlides: 0,
  index: 1,
}

const fn = {
  init: () => {
    if ($slider.querySelectorAll('.swiper-slide').length < 2) {
      return
    }

    state.numSlides = $slider.querySelectorAll('.swiper-slide').length

    const swiper = new Swiper($slider.querySelector('.swiper-container'), {
      autoHeight: true,
      effect: 'fade',
      loop: true,
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        prevEl: $slider.querySelector('.slider-prev'),
        nextEl: $slider.querySelector('.slider-next'),
      },
    })

    swiper.on('slideNextTransitionStart', function () {
      state.index += 1

      if (state.index > state.numSlides) {
        state.index = 1
      }
    })

    swiper.on('slidePrevTransitionStart', function () {
      state.index -= 1

      if (state.index <= 0) {
        state.index = state.numSlides
      }
    })

    swiper.on('slideChangeTransitionEnd', function () {
      const $count = $slider.querySelector('.swiper-slide-counter span')

      $count.textContent = state.index
    })
  },
}

export default {
  can: () => $slider,
  run: fn.init,
}
